const INTERNAL_TITLE_SEPARATOR = ' - ';
const INTERNAL_TITLE_SUFFIX = 'cubic';

export function buildInternalTitle(...segments: Array<string | null | undefined>): string {
  const normalized = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));

  if (normalized.length === 0) {
    return INTERNAL_TITLE_SUFFIX;
  }

  return `${normalized.join(INTERNAL_TITLE_SEPARATOR)} | ${INTERNAL_TITLE_SUFFIX}`;
}
